export enum ProjectApproaches {
    CLASSIC = 'CLASSIC',
    AGILE = 'AGILE',
    HYBRID = 'HYBRID'
}